// This is a generated file. Don't edit. Run npm run vers -- major, minor, or patch to bump the version.

export const PACKAGE_VERSION = "1.2.3";
